<div
  class="trigger__item"
  [class.selected]="selected"
  (click)="selected = !selected"
>
  <div class="trigger__item__header">Trigger</div>
  <div class="trigger__item__body">body</div>
</div>
